/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M33.114 0L12.845 22.522 11.507 24l1.338 1.478L33.114 48l3.379-2.956L17.56 24 36.493 2.956 33.114 0z" fill-rule="nonzero"/>'
}
